// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__SZVwf","content":"Detail_content__OWWoZ","image":"Detail_image__G0nih","description":"Detail_description__T9agS"};